import { handleActions } from 'redux-actions';
import { sum } from 'lodash-es';

import {
  PropertySizeFilterValue,
  PropertySizeFilterCount,
  FacilitiesFilterCount,
  FacilitiesValue,
  AmenitiesValue,
  AmenitiesFilterCount,
  RadiusValue,
} from 'ha/types/SearchFilters';

import { SearchResponse } from '@algolia/client-search';
import { FiltersState } from './Types';
import { Actions } from '../constants';

const initialState = {
  propertySize: {
    listingCount: {},
    value: {},
    stats: {
      minValue: undefined,
      maxValue: undefined,
    },
  },
  facilities: {
    listingCount: {},
    value: [],
    isHidden: false,
  },
  amenities: {
    listingCount: {},
    value: [],
    isHidden: false,
  },
  radius: {
    value: RadiusValue.DEFAULT,
  },
};

interface Payload {
  filtersCount: {
    propertySize: PropertySizeFilterCount;
    facilities: FacilitiesFilterCount;
    amenities: AmenitiesFilterCount;
  };
  globalFiltersCount: {
    facilities: FacilitiesFilterCount;
    amenities: AmenitiesFilterCount;
  };
  propertySizeMin: number;
  propertySizeMax: number;
  noFiltersFacet?: SearchResponse;
  sizeMin: PropertySizeFilterValue['sizeMin'];
  sizeMax: PropertySizeFilterValue['sizeMax'];
  facilities: FacilitiesValue;
  amenities: AmenitiesValue;
  radius: RadiusValue | undefined;
}

export default handleActions<FiltersState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,

      propertySize: {
        ...state.propertySize,
        listingCount: payload.filtersCount.propertySize,
        stats: {
          minValue: payload.propertySizeMin,
          maxValue: payload.propertySizeMax,
        },
      },

      facilities: {
        ...state.facilities,
        listingCount: payload.filtersCount.facilities,
        isHidden:
          sum(Object.values(payload.globalFiltersCount.facilities)) === 0,
      },

      amenities: {
        ...state.amenities,
        listingCount: payload.filtersCount.amenities,
        isHidden:
          sum(Object.values(payload.globalFiltersCount.amenities)) === 0,
      },
      noFiltersFacet: payload.noFiltersFacet || state.noFiltersFacet,
    }),

    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      {
        payload: { sizeMin, sizeMax, facilities = [], amenities = [], radius },
      },
    ) => ({
      ...state,

      propertySize: {
        ...state.propertySize,
        value: {
          sizeMin: Number(sizeMin) || undefined,
          sizeMax: Number(sizeMax) || undefined,
        },
      },

      facilities: {
        ...state.facilities,
        value: Array.isArray(facilities) ? facilities : [facilities],
      },

      amenities: {
        ...state.amenities,
        value: Array.isArray(amenities) ? amenities : [amenities],
      },

      radius: {
        ...state.radius,
        value:
          radius && Object.values(RadiusValue).includes(radius)
            ? radius
            : RadiusValue.DEFAULT,
      },
    }),
  },
  initialState,
);
